import 'css-chunksrc/client/common/layout/zonesList/loader/zone/styles.scss';export default {
  "zone": "_zone_ayuhl_1",
  "header": "_header_ayuhl_5",
  "icon": "_icon_ayuhl_15",
  "avatar": "_avatar_ayuhl_23",
  "mainHeader": "_mainHeader_ayuhl_31",
  "mainTitle": "_mainTitle_ayuhl_39",
  "name": "_name_ayuhl_45",
  "nameLoader": "_nameLoader_ayuhl_55"
};